export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6782.b36b53c1.jpg";